export default __webpack_public_path__ + "static/georgim-e2436dbd34f3c3934c9954424607290d.png";